import { EdgeGetZonesByIdsRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { GetZonesByIds } from '@/shared/domain/use-cases'

export function makeGetZonesByIds(): GetZonesByIds {
  return new EdgeGetZonesByIdsRepository(makeSupabaseEdgeHttpClient()).execute
}
